import { Component, OnInit } from '@angular/core';
import { DomSanitizer,SafeHtml } from '@angular/platform-browser';
import { BaseComponent } from '../../share/component/base.component';
declare var $;
@Component({
  selector: 'history-component',
  templateUrl: './history.component.html'
})
export class HistoryComponent extends BaseComponent implements OnInit  {

  constructor(  
    public _sanitizer: DomSanitizer
  ) {
    super();
  }
  public contact;
  ngOnInit() {
    //取得聯絡人
    this.baseApi.apiGet('v1/member/companyUser',{}).then((c_res)=>{
      this.contact = c_res;
      this.Submit();
    });
  }

  public Data;
  Submit(){
    this.baseApi.apiGet('v1/member/session',{history:true}).then((res:any)=>{
      //console.log('session',res);
      //整理資料
      if(res){
        var newData = [];
        res.forEach(item => {
          var _e = item['Event'];
          var _self = item;
          //處理審核狀態
          _self['statusType'] =  this.StatusClass(_self['status']);
          var _index = newData.findIndex((evt)=>{
             return evt['evt']['id'] == item['Event']['id'];
           });
          if(_index > -1){
            newData[_index]['list'].push(_self);
          }else{
            var _n ={
              evt:_e,
              list:[_self]
            };
            newData.push(_n);
          }
        });
        //console.log('newData',newData);
        this.Data = newData;
      }
    });
  }

  StatusClass(index){
    var statusObj = {
      1:{name:'審核中',class:'checking'},
      2:{name:'審核通過',class:'passed'},
      3:{name:'審核不通過',class:'fail'},
      5:{name:'取消',class:'fail'}
    };
    return statusObj[index];
  };

  VideoEvt(item){
    var d = item['sessionTime']['start'];
    var date = '';
    if(d){
      date = d.split('T');
    }
    //20220221移除
    // if(date[0]){
    //   this.pop.setConfirm({
    //     content:'<span class="view_alert"><img src="/assets/images/time-left.png" class="pop_img">本活動尚未開始，請於' + date[0] + '日<br/>由此入口進行視訊洽談</span>',
    //     checkTxt:'確認'
    //   });
    // }
  }
}
